<template>
  <div>
    <v-snackbar v-model="snackbar">
      Requisição de amizade realizada com sucesso.
      <template v-slot:action="{ attrs }">
        <v-btn color="#F15A24" text v-bind="attrs" @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
    <v-menu bottom offset-x left v-model="menuShow" :close-on-content-click="false" transition="scale-transition">
      <template v-slot:activator="{ on, attrs }" >
        <div>
        <input type="text" placeholder="Pesquise por usuários na plataforma" v-model="searchUser"
            style="width: 80%; margin-right:10px; padding: 0.5rem; border:1px solid" class="rounded-lg" />
            <button :disabled="loadingUsers" @click="filterUsers()" class="btn btn-secondary pa-2" 
              style="
                border-radius: 5px;
                background-color: #F15A24;
                color: white;
              "
              v-on="on"
            >
            <v-progress-circular v-if="loadingUsers" indeterminate></v-progress-circular>
            <span v-if="!loadingUsers"><v-icon color="white">mdi-magnify</v-icon></span>
          </button>
          </div>
      </template>
      <v-card width="550" class="text-center" elevation="2" sytle="max-width:450px; overflow-x:auto">
        <v-card-title>Adicionar novo amigo</v-card-title>
        <!-- <div style="margin-left: 0.5rem; padding-bottom: 0.3rem" v-for="userToAdd in usersToAdd" :key="userToAdd.id">
          <v-chip class="chip-with-hover">
            {{
      `${userToAdd.first_name} ${userToAdd.last_name !== null ? userToAdd.last_name : ""
      }`
    }}
          </v-chip>
          <v-icon @click="removeUserFromUsersToAdd(userToAdd)" class="remove-icon">mdi-close</v-icon>
        </div> -->
        <v-card-text>
          <v-list class="mt-3" style="max-height:60vh; overflow-y: auto;">
            <v-list-item v-if="filteredUsers.length === 0">
              <v-list-item-content class="d-flex justify-center">
                 {{searched ? `O nome digitado não foi encontrado` : `Digite o nome do seu amigo e clique em pesquisar`}} 
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-for="user in filteredUsers" :key="user.id" 
              class="chip-with-hover " style="padding: 0.2rem; margin-bottom: 0.2rem;">
              <v-list-item-icon class="d-flex justify-center mr-3">
                <v-icon size="40px" v-if="!user.avatar" color="#F15A24" >
                  mdi-account
                </v-icon>
                <v-img width="40px" v-if="user.avatar" height="40px" class="rounded-circle" 
									:src="`https://api.mylegis.com.br/assets/${user.avatar}`" />
              </v-list-item-icon>
                <v-list-item-content class="text-left">
              <router-link :to="`/painel/u/${user.id}/${sanitizeTitle(user.first_name)}`" class="">

                <v-list-item-title>
                  {{ user.first_name }} {{ user.last_name || "" }}
                </v-list-item-title>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
            </router-link>

              </v-list-item-content>
              <v-list-item-action>
                <v-btn color="#F15A24" text small @click="adicionar(user)" :disabled="user.adicionado">{{user.adicionado ? `Adicionado` : `Adicionar` }}</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <!-- <v-autocomplete
            v-model="values"
            color="#4f2d7f"
            :items="users"    
            item-text="first_name"
            item-value="id"
            label="Pesquise pelo email">
                <template v-slot:selection="data">
                    <v-chip
                    v-bind="data.attrs"
                    :input-value="data.selected"
                    @click="data.select"
                    @click:close="remove(data.item)"
                    >
                    {{ `${data.item.first_name} ${data.item.last_name !== null ? data.item.last_name : "" }`}}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                    <template v-if="typeof data.item !== 'object'" >
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                        <v-list-item-content>
                            <v-list-item-title v-html="`${data.item.first_name} ${data.item.last_name !== null ? data.item.last_name : ''}`"></v-list-item-title>
                            <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
                        </v-list-item-content>
                    </template>
                </template>
            </v-autocomplete>  -->
        </v-card-text>

      </v-card>
    </v-menu>
  </div>
</template>
<style scoped>
.chip-with-hover:hover {
  border: 1px solid #f15a24;
  border-radius: 5px;
}

a {
  text-decoration: none;
  color: black;
}

a:hover {
  text-decoration: underline;
  color: #F15A24;
}

</style>
<script>
export default {
  name: "BtnAdicionar",
  props: { link: String, titulo: String, reloadFriends: Function },
  data() {
    return {
      menuShow: false,
      snackbar: false,
      values: [],
      searchUser: "",
      usersToAdd: [],
      filteredUsers: [],
      loadingUsers: false,
      searched: false
    };
  },
  mounted() {
    //    this.getUsuarios()
  },
  computed: {
    users() {
      return this.$store.state.users;
    },

  },
  methods: {
    sanitizeTitle: function (title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    adicionar(user) {
      let share = {
        id_adicionado: user.id,
        id_usuario: this.$store.state.user.id,
      };

      this.$http.post("items/add_amigo", share).then((response) => {
        if (response.data.data.id != undefined) {
          // this.menuShow = false;
          this.snackbar = true;
          user.adicionado=true
          this.reloadFriends();
          // this.cleanFields();
        }
      });
    },
    cleanFields() {
      this.filteredUsers = [];
      this.searchUser = "";
      this.searched = "";
    },
    async filterUsers() {
      if (this.searchUser === "") { this.cleanFields(); return }
      this.searched=true
      this.loadingUsers = true
      this.searchUser = this.searchUser.trim()
      await this.$store.dispatch("searchUsuarios", this.searchUser)
      this.filteredUsers = this.users
      this.loadingUsers = false
    },
    // pushUserToUsersToAdd(user) {
    //   if (this.usersToAdd.includes(user)) return;
    //   else this.usersToAdd.push(user);
    // },
    // removeUserFromUsersToAdd(userToRemove) {
    //   const index = this.usersToAdd.findIndex(
    //     (user) => user.id === userToRemove.id
    //   );
    //   if (index !== -1) {
    //     this.usersToAdd.splice(index, 1);
    //   }
    // },

  },
};
</script>
